export class TradesPerYearData {
    private tradesPerYear: string[] = ['1-10', '11-25', '26-50', '51-100', '>100'];
    public getTradesPerYear(): Array<string> {
        return this.tradesPerYear;
    }
}
